import { IdentifyConfig } from '../../../app/config/model/identify-config.model';
import { Workspace } from '../../../app/shared/enum/workspace.enum';
import { LayerCode } from '../../../app/shared/enum/layer-code.enum';

export const IDENTIFY_CONFIG: IdentifyConfig = {
  layers: [
    {
      workspace: Workspace.nonWorkspace,
      fkLayer: LayerCode.av_webgis_sw_liegenschaften,
      layerIds: [22, 23, 24, 25],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 22,
          label: 'POPUP.AV_SW.OBJEKTID',
          displayField: ['kanton','nummer', 'nummerteilgrundstueck', 'egris_egrid'],
          title: 'IDENTIFY_CONFIG.PROJEKTIERTE_GRUNDSTUECKE',
        },
        {
          layerId: 23,
          label: 'POPUP.AV_SW.OBJEKTID',
          displayField: ['kanton','nummer', 'nummerteilgrundstueck', 'egris_egrid'],
          title: 'IDENTIFY_CONFIG.PROJEKTIERTE_SELBSTAENDIGE_RECHTE',
        },
        {
          layerId: 24,
          label: 'POPUP.AV_SW.OBJEKTID',
          displayField: ['kanton','nummer', 'nummerteilgrundstueck', 'egris_egrid'],
          title: 'IDENTIFY_CONFIG.GRUNDSTUECKE',
        },
        {
          layerId: 25,
          label: 'POPUP.AV_SW.OBJEKTID',
          displayField: ['kanton','nummer', 'nummerteilgrundstueck', 'egris_egrid'],
          title: 'IDENTIFY_CONFIG.SELBSTAENDIGE_RECHTE',
        },
      ],
    },
    {
      workspace: Workspace.sbb_eigentumsflaeche,
      fkLayer: LayerCode.parzellen,
      layerIds: [0, 1, 3],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 0,
          label: 'POPUP.ARBEITSBEREICH.IMMOBILIEN.PARZELLE',
          displayField: ['EIGENTUM', 'PARZNR'],
          title: 'IDENTIFY_CONFIG.PARZELLE',
        },
        {
          layerId: 1,
          label: 'POPUP.ARBEITSBEREICH.IMMOBILIEN.TEILPARZELLE',
          displayField: ['OBJEKTNR'],
          title: 'IDENTIFY_CONFIG.TEILPARZELLE',
        },
        {
          layerId: 3,
          label: 'POPUP.ARBEITSBEREICH.IMMOBILIEN.PARZELLE_Dritt',
          displayField: ['EIGENTUM', 'PARZNR'],
          title: 'IDENTIFY_CONFIG.PARZELLE_Dritt',
        },
      ],
    },
    {
      workspace: Workspace.verkaufsobjekte,
      fkLayer: LayerCode.verkaufsobjekte,
      layerIds: [9],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 9,
          label: 'POPUP.ARBEITSBEREICH.VERKAUF.VERKAUFSOBJEKTE',
          displayField: ['ID_SAP'],
          title: 'IDENTIFY_CONFIG.TRANSAKTIONOBJEKT',
        },
      ],
    },
    {
      workspace: Workspace.strategieflaechen,
      fkLayer: LayerCode.strategieflaeche,
      layerIds: [6],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 6,
          label: 'POPUP.ARBEITSBEREICH.STRATEGIEFLAECHEN.ID',
          displayField: ['ID'],
          title: 'IDENTIFY_CONFIG.STRATEGIEFLAECHE',
        },
      ],
    },
    {
      workspace: Workspace.sap,
      fkLayer: LayerCode.sap,
      layerIds: [12, 13],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 12,
          label: 'POPUP.ARBEITSBEREICH.SAP.SAP_REFX_GEBAEUDE',
          displayField: ['TEXT_ANLAGENHAUPTNR'],
          title: 'IDENTIFY_CONFIG.SAP_REFX_Gebaeude',
        },
        {
          layerId: 13,
          label: 'POPUP.ARBEITSBEREICH.SAP.SAP_REFX_GRUNDSTUECK',
          displayField: ['KEY'],
          title: 'IDENTIFY_CONFIG.SAP_REFX_Grundstuecke',
        },
        {
          layerId: 3,
          label: 'POPUP.ARBEITSBEREICH.SAP.STUDIEN',
          displayField: ['ID'],
          title: 'IDENTIFY_CONFIG.SAP_STUDIEN',
        },
        {
          layerId: 4,
          label: 'POPUP.ARBEITSBEREICH.SAP.PROJEKTE',
          displayField: ['PROJEKTBEZEICHNUNG'],
          title: 'IDENTIFY_CONFIG.SAP_PROJEKTE',
        },
      ],
    },
    {
      workspace: Workspace.nutzflaecheInfra,
      fkLayer: LayerCode.nutzflaeche_infra,
      layerIds: [7],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 7,
          label: 'POPUP.ARBEITSBEREICH.STRATEGIEFLAECHEN.ORG_TEXT',
          displayField: ['ORG_TEXT'],
          title: 'IDENTIFY_CONFIG.NUTZFLAECHEN_INFRA',
        },
      ],
    },
    {
      workspace: Workspace.areale,
      fkLayer: LayerCode.areale_view,
      layerIds: [0],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 0,
          label: 'POPUP.ARBEITSBEREICH.AREALE.ORG_TEXT',
          displayField: ['REFX_BEZEICHNUNG'],
          title: 'IDENTIFY_CONFIG.AREALE',
        },
      ],
    },
    {
      workspace: Workspace.denkmalpflege,
      fkLayer: LayerCode.denkmalpflege,
      layerIds: [5, 40],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 5,
          label: 'EO',
          displayField: ['OBJEKTTITEL_EO'],
          title: 'IDENTIFY_CONFIG.EO',
        },
        {
          layerId: 40,
          label: 'KO',
          displayField: ['OBJEKTTITEL'],
          title: 'IDENTIFY_CONFIG.KO',
        },
      ],
    },
    {
      workspace: Workspace.gebaeude,
      fkLayer: LayerCode.gebaeude,
      layerIds: [12706],
      tolerance: 10,
      popUpsInfo: [
        {
          layerId: 12706,
          label: 'POPUP.ARBEITSBEREICH.GEBAEUDE.OBJEKTTYP',
          displayField: ['OBJEKTTYP'],
          title: 'IDENTIFY_CONFIG.GEBAEUDE',
        },
      ],
    },
  ],
};
